export interface IPattern {
  DIGIT_REGEX: RegExp;
  EMAIL_REGEX: RegExp;
  SYMBOL_REGEX: RegExp;
  US_PHONE_REGEX: RegExp;
}

export interface IConstant {
  initialCopyrightYear: number;
  patterns: IPattern;
  MAXFILESIZE: number;
  MAXFILENAMELENGTH: number;
}

export const Constants: IConstant = {
  initialCopyrightYear: 2021,
  patterns: {
    DIGIT_REGEX: /[0-9]/,
    EMAIL_REGEX:
      /^[a-z0-9!#$%&'*+\/=?^_\`{|}~.-]+@[a-z0-9]([a-z0-9-])+(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i,
    SYMBOL_REGEX: /[-+_!@#$%^&*,.?]/,
    US_PHONE_REGEX: /(^\d{10}$)/,
  },
  // 50MB
  MAXFILESIZE: 50e6,
  MAXFILENAMELENGTH: 100,
};

export const months = [
  'JAN',
  'FEB',
  'MAR',
  'APR',
  'MAY',
  'JUN',
  'JUL',
  'AUG',
  'SEP',
  'OCT',
  'NOV',
  'DEC',
];
export const ROUTES = {
  app: {
    notFound: {
      name: '**',
      path: '**',
      title: 'Not Found',
    },
    home: {
      path: 'home',
    },
  },
  admin: {
    root: 'admin',
    default: 'dashboard',
    dashboard: {
      name: 'dashboard',
      path: 'admin/dashboard',
      title: 'Dashboard',
    },
    createUser: {
      name: 'create',
      path: 'create',
      title: 'Create User',
    },
    updateUser: {
      name: 'update-user/:id',
      path: 'admin/update-user',
      title: 'Update User',
    },
    userList: {
      name: 'user-list',
      path: 'admin/user-list',
      title: 'User List',
    },
    schoolList: {
      name: 'school-list',
      path: 'admin/school-list',
      title: 'School List',
    },
    createSchool: {
      name: 'create-school',
      path: 'admin/create-school',
      title: 'Create School',
    },
    updateSchool: {
      name: 'update-school/:id',
      path: 'admin/update-school',
      title: 'Update School',
    },
    gradeLevelList: {
      name: 'grade-units',
      path: 'admin/grade-units',
      title: 'Select Grade Level',
    },
    gradeUnitList: {
      name: 'grade-unit/grades/:gradeLevel/units',
      path: 'admin/grade-unit/grades/:gradeLevel/units',
      title: 'Unit List',
    },
    createGradeUnit: {
      name: 'grade-unit/grades/:gradeLevel/units/create',
      path: 'admin/grade-unit/:gradeLevel/units/create',
      title: 'Add Unit',
    },
    updateGradeUnit: {
      name: 'grade-unit/grades/:gradeLevel/units/:unitNumber/update',
      path: 'admin/grade-unit/grades/:gradeLevel/units/:unitNumber/update',
      title: 'Update Unit',
    },
    gradeUnitDayList: {
      name: 'grade-unit/grades/:gradeLevel/units/:unitNumber/days',
      path: 'admin/grade-unit/grades/:gradeLevel/units/:unitNumber/days',
      title: 'Unit Day List',
    },
    createGradeUnitDay: {
      name: 'grade-unit/grades/:gradeLevel/units/:unitNumber/days/create',
      path: 'admin/grade-unit/grades/:gradeLevel/units/:unitNumber/days/create/',
      title: 'Add Instruction Day',
    },
    updateGradeUnitDay: {
      name: 'grade-unit/grades/:gradeLevel/units/:unitNumber/days/:dayNumber/update',
      path: 'admin/grade-unit/grades/:gradeLevel/units/:unitNumber/days/:dayNumber/update',
      title: 'Update Instruction Day',
    },
    gradeUnitDayBlocks: {
      name: 'grade-unit/grades/:gradeLevel/units/:unitNumber/days/:dayNumber/blocks/preview',
      path: 'admin/grade-unit/grades/:gradeLevel/units/:unitNumber/days/:dayNumber/blocks/preview',
      title: 'View Day Blocks',
    },
    updateGradeUnitDayBlocks: {
      name: 'grade-unit/grades/:gradeLevel/units/:unitNumber/days/:dayNumber/blocks/update',
      path: 'admin/grade-unit/grades/:gradeLevel/units/:unitNumber/days/:dayNumber/blocks/update',
      title: 'Edit Day Blocks',
    },
    gradeUnitDayItemList: {
      name: 'grade-unit/:gradeLevel/:unitNumber/:dayNumber',
      path: 'admin/grade-unit/:gradeLevel/:unitNumber',
      title: 'Unit Day Item List',
    },
    createGradeUnitDayItem: {
      name: 'grade-unit/:gradeLevel/:unitNumber/:dayNumber/create',
      path: 'admin/grade-unit/:gradeLevel/:unitNumber/:dayNumber/create/',
      title: 'Unit Day Builder',
    },
    updateGradeUnitDayItem: {
      name: 'grade-unit/:gradeLevel/:unitNumber/:dayNumber/update/:itemId',
      path: 'admin/grade-unit/:gradeLevel/:unitNumber/:dayNumber/update/',
      title: 'Update Unit Day',
    },
  },
  auth: {
    root: 'auth',
    default: 'main-login',
    activateAccount: {
      name: 'activate-account/:token',
      path: 'auth/activate-account',
      title: 'Activate Account',
    },
    forgotPassword: {
      name: 'forgot-password',
      path: 'auth/forgot-password',
      title: 'Forgot Password',
    },
    forgotPasswordConfirmation: {
      name: 'forgot-password-confirmation',
      path: 'auth/forgot-password-confirmation',
      title: 'Forgot Password Confirmation',
    },
    googleOAuth: {
      name: 'google-oauth',
      path: 'auth/google-oauth',
      title: 'Log In With Google',
    },
    login: {
      name: 'login',
      path: 'auth/login',
      title: 'Log In',
    },
    logout: {
      name: 'logout',
      path: 'auth/logout',
      title: 'Logged Out',
    },
    mainLogin: {
      name: 'main-login',
      path: 'auth/main-login',
      title: 'Log In',
    },
    resetPassword: {
      name: 'reset-password/:token',
      path: 'auth/reset-password',
      title: 'Reset Password',
    },
    signUp: {
      name: 'signup',
      path: 'auth/signup',
      title: 'Sign Up',
    },
    accountType: {
      name: 'account-type',
      path: 'auth/account-type',
      title: 'Account Type',
    },
    teacherInstructions: {
      name: 'teacher-instructions',
      path: 'auth/teacher-instructions',
      title: 'Teacher Instructions',
    },
    studentInstructions: {
      name: 'student-instructions',
      path: 'auth/student-instructions',
      title: 'Student Instructions',
    },
  },
  student: {
    root: 'student',
    default: 'dashboard',
    dashboard: {
      name: 'dashboard',
      path: 'student/dashboard',
      title: 'Student Dashboard',
    },
    classroomList: {
      name: 'classes',
      path: 'student/classroom-list',
      title: 'Classroom List',
    },
    gradingClassroomList: {
      name: 'classes',
      path: 'student/classroom-list',
      title: 'Grading Classroom List',
    },
    assignmentDetail: {
      name: 'assignment-detail/:id',
      path: 'student/assignment-detail',
      title: 'Assignment Detail',
    },
    assignmentList: {
      name: 'assignments',
      path: 'student/assignment-list',
      title: 'Unit Assignment List',
    },
    assignmentUnitDaysList: {
      name: 'assignment-list/:unitNumber/days',
      path: 'student/assignment-list/:unitNumber/days',
      title: 'Day Assignment List',
    },
    gradeUnitList: {
      name: 'grade-units',
      path: 'student/grade-units',
      title: 'Unit List',
    },
    gradeUnitDayList: {
      name: 'grade-units/:unitNumber/days',
      path: 'student/grade-units/:unitNumber/days',
      title: 'Unit Day List',
    },
    gradeUnitDayDetail: {
      name: 'grade-units/:unitNumber/days/:dayNumber',
      path: 'student/grade-units/:unitNumber/days/:dayNumber',
      title: 'Unit Day Detail',
    },
    profile: {
      name: 'profile',
      path: 'user/profile',
      title: 'Utility',
    },
  },
  teacher: {
    root: 'teacher',
    default: 'dashboard',
    dashboard: {
      name: 'dashboard',
      path: 'teacher/dashboard',
      title: 'Teacher Dashboard',
    },
    classList: {
      name: 'classes',
      path: 'teacher/classes',
      title: 'Class List',
    },
    createClass: {
      name: 'create',
      path: 'teacher/classes/create',
      title: 'Create Class',
    },
    updateClass: {
      name: 'update-class/:id',
      path: 'teacher/classes',
      title: 'Update Class',
    },
    classroomStudentList: {
      name: ':classroomId/student-list',
      path: 'teacher/classes/:classroomId/student-list',
      title: 'Student List',
    },
    createGradingPeriod: {
      name: ':classroomId/grading-period',
      path: 'teacher/classes/:classroomId/grading-period',
      title: 'Create Grading Period',
    },
    updateGradingPeriod: {
      name: ':classroomId/grading-period/:gradingPeriodId',
      path: 'teacher/classes/:classroomId/grading-period/:gradingPeriodId',
      title: 'Update Grading Period',
    },
    editGradingPeriod: {
      name: ':classroomId/edit-grading-period/:gradingPeriodId',
      path: 'teacher/classes/:classroomId/edit-grading-period/:gradingPeriodId',
      title: 'Edit Grading Period',
    },
    inviteStudent: {
      name: ':classroomId/invite-student',
      path: 'teacher/classes/:classroomId/invite-student',
      title: 'Invite Student',
    },
    updateStudent: {
      name: ':classroomId/update-student/:studentId',
      path: 'teacher/classes/:classroomId/update-student/:studentId',
      title: 'Update Student',
    },
    updateStudentPassword: {
      name: ':classroomId/update-student-password/:studentId',
      path: 'teacher/classes/:classroomId/update-student-password/:studentId',
      title: 'Update Student Password',
    },
    grades: {
      name: 'classes/:classroomId/grade-units',
      path: 'teacher/classes/:classroomId/grade-units',
      title: 'Grades',
    },
    gradeUnitList: {
      name: 'grades/:gradeLevel/units',
      path: 'teacher/classes/:classroomId/grade-units/grades/:gradeLevel/units',
      title: 'Unit List',
    },
    gradeUnitDayList: {
      name: 'grades/:gradeLevel/units/:unitNumber/days',
      path: 'teacher/classes/:classroomId/grade-units/grades/:gradeLevel/units/:unitNumber/days',
      title: 'Unit Day List',
    },
    gradeUnitDayDetail: {
      name: 'classes/:classroomId/grade-units/grades/:gradeLevel/units/:unitNumber/days/:dayNumber',
      path: 'teacher/classes/:classroomId/grade-units/grades/:gradeLevel/units/:unitNumber/days/:dayNumber',
      title: 'Unit Day Detail',
    },
    gradeViews: {
      name: 'grading/classrooms/:classroomId/grades/:gradingPeriod/units/:unitNumber/grade-views',
      path: 'teacher/grading/classrooms/:classroomId/grades/:gradingPeriod/units/:unitNumber/grade-views',
      title: 'Grade Views',
    },
    gradeUnitDay: {
      name: 'grading/classrooms/:classroomId/grading-period/:gradingPeriod/units/:unitNumber/unit-grading/days/:dayId',
      path: 'teacher/grading/classrooms/:classroomId/grading-period/:gradingPeriod/units/:unitNumber/unit-grading/days/:dayId',
      title: 'Unit Grading Day',
    },
  },
  user: {
    root: 'user',
    default: 'profile',
    changePassword: {
      name: 'change-password',
      path: 'user/change-password',
      title: 'Change Password',
    },
    studentAgreement: {
      name: 'student-agreement',
      path: 'user/student-agreement',
      title: 'Student Agreement',
    },
    teacherAgreement: {
      name: 'teacher-agreement',
      path: 'user/teacher-agreement',
      title: 'Teacher Agreement',
    },
    profile: {
      name: 'profile',
      path: 'user/profile',
      title: 'Update Profile',
    },
  },
};

export const MESSAGES = {
  guard: {
    notAuthenticated: `You cannot view the requested page. Returning to the login page.`,
    notAuthorized: `You cannot view the requested page. Returning to the dashboard.`,
    notEnrolled: `You must first join a class. Returning to classrooms.`,
    notAuthorizedStudent: `Oops! You can't go here. Returning to the dashboard.`,
    notAcceptedAgreements: `Oops! You need to accept the user agreements before you can use the rest of this site.`,
    invalidToken: `This link has expired.`,
  },
  resolver: {
    gradingPeriodDetailError: `Unable to load class. Returning to students list.`,
    schoolDetailError: `Unable to load school. Returning to school list.`,
    schoolListError: `Unable to load schools. Returning to user list.`,
    assignmentDetailError: `Oops! The assignment didn't load. Returning to the assignment list.`,
    classroomCodeError: `Unable to load classroom code. Returning to class list.`,
    gradeUnitListError: `Unable to load unit list. Returning to the grade list.`,
    gradeUnitDayDetailError: `Unable to load unit day page. Returning to the unit list.`,
    gradeUnitDayListError: `Unable to load unit day list. Returning to the unit list.`,
    dayBlockError: `Unable to load blocks.  Returning to day list`,
    classroomDetailError: `Unable to load class. Returning to class list.`,
    studentDetailError: `Unable to load student. Returning to student list.`,
    loggedInUserError: `Unable to load user information. Returning to the dashboard.`,
    roleListError: `Unable to load roles. Returning to user list.`,
    userDetailError: `Unable to load user. Returning to user list.`,
    returnToDashboard: `Could not load resource. Returning to Dashboard`,
  },
};

// TODO: We'll need a real email eventually - for now just keeping it defined as a const right here, unless it needs to be configurable on the backend
export const STAFF_EMAIL = 'test@test.com';

export enum BLOCK_TYPES {
  KaraokeBlock = 'KaraokeBlock',
  ImageBlock = 'ImageBlock',
  EmbedBlock = 'EmbedBlock',
  VideoEmbedBlock = 'VideoEmbedBlock',
  WYSIWYGBlock = 'WYSIWYGBlock',
  QUIZ = 'Quiz',
  QuizBlock = 'QuizBlock',
  QuizStackBlock = 'QuizStackBlock',
  DocumentBlock = 'DocumentBlock',
}

export const ScoringRubric = [
  { name: 'Emerging', score: 1 },
  { name: 'Developing', score: 2 },
  { name: 'Proficient', score: 3 },
  { name: 'Exemplary', score: 4 },
];

export enum RubricScores {
  EMERGING = 1,
  DEVELOPING = 2,
  PROFICIENT = 3,
  EXEMPLARY = 4,
}

export enum SkillsRubric {
  DISCUSSIONS = 'Participated in class discussions',
  UNDERSTANDING = 'Demonstrates understanding of concepts',
  WRITING = 'Completed writing and drawing tasks',
  LISTENING = 'Listened as the unit was read to them',
  ACTIVITIES = 'Participated in hands-on activities',
}

export const TEST_BUCKET = 'stemtaught-test-bucket';

export const GradeImages = {
  K: 'assets/img/Kinder-Boxset.png',
  1: 'assets/img/Grade-1-Boxset.png',
  2: 'assets/img/Grade-2-Boxset.png',
  3: 'assets/img/Grade-3-Boxset.png',
  4: 'assets/img/Grade-4-Boxset.png',
  5: 'assets/img/Grade-5-Boxset.png',
  6: 'assets/img/Grade-6-Boxset.png',
};

export const TOTAL_NOTE_POINTS = 30;
